<template>
  <div>
    <el-tag v-if="['new'].includes(status)" type="info">
      Cadastro
    </el-tag>
    <el-tag v-if="['risk_analysis', 'risk_analysis_error', 'risk_analysis_reproved', 'risk_analysis_manually', 'risk_analysis_approved', 'risk_analysis_rejected', 'risk_analysis_awaiting'].includes(status)" type="info">
      Análise de Risco
    </el-tag>
    <el-tag v-if="['bank_account', 'bank_account_approved', 'bank_account_reproved', 'bank_account_error'].includes(status)" type="info">
      Domicilio Bancário
    </el-tag>
    <el-tag v-if="['acquirers', 'acquirers_approved', 'acquirers_reproved', 'acquirers_error'].includes(status)" type="info">
      Adquirente
    </el-tag>
    <el-tag v-if="['gateway', 'gateway_approved', 'gateway_error'].includes(status)" type="info">
      Gateway
    </el-tag>
    <el-tag v-if="['plan', 'plan_reproved'].includes(status)" type="info">
      Planos
    </el-tag>
    <el-tag v-if="['terminal', 'terminal_reproved'].includes(status)" type="info">
      Terminal
    </el-tag>
    <el-tag v-if="['active'].includes(status)" type="info">
      Concluído
    </el-tag>
    <el-tag v-if="['cancelled', 'inactive'].includes(status)" type="info">
      Cadastro
    </el-tag>
  </div>
</template>

<script>
export default {
  name: "StatusCapta",
  props: ["status"],
  data() {
    return {
    };
  },
};
</script>

<style scoped></style>
